import { Breadcrumbs } from '@cp/ds/src/components/breadcrumbs';
import { Container } from '@cp/ds/src/components/container';
import { Typography } from '@cp/ds/src/components/typography';
import React from 'react';
import { RoutedLink } from 'src/shared/ui/link';
import { Box } from '@cp/ds/src/components/box';
import { toAsset } from '@cp/shared/image';

import ImgUser1 from './assets/feedback-1.jpg';
import ImgUser2 from './assets/feedback-2.jpg';
import ImgUser3 from './assets/feedback-3.jpg';
import ImgUser4 from './assets/feedback-4.jpg';
import ImgUser5 from './assets/feedback-5.jpg';
import ImgUser6 from './assets/feedback-6.jpg';

import { FeedbackItem } from './components/feedbackItem';

const reviews = [
  {
    image: toAsset(ImgUser6),
    name: 'Елизавета Хохлова',
    date: '10 мая 2022 г.',
    text: 'Необходимость клининговых услуг в современном мире набирает обороты. Вот и мне потребовались услуги домработницы, так как нахожусь в декрете с малышами. Времени на уборку не остается совсем, а квадратных метров дома много. Впускать к себе человека без рекомендаций и проверки страшно. Обратилась к сайту YouHelp. На сайте можно подобрать кандидатуру, просмотреть анкету, отзывы о ее работе. Спасибо за хороший сайт, который упростил поиск помощницы по дому.',
    href: 'https://vk.com/id582009316',
  },
  {
    image: toAsset(ImgUser5),
    name: 'Анна Левицкая',
    date: '11 января 2022 г.',
    text: 'Искала няню со знанием английского языка, чтобы несколько раз в неделю она могла сидеть с сыном по 3-4 часа, попутно общаясь с ним на английском языке. На YouHelp достаточно быстро удалось найти несколько подходящих специалистов и в конечном итоге заключила договор с квалифицированной няней. Отдельно хочу отметить, что на портале YouHelp действительно очень большой выбор специалистов по уходу за детьми, есть удобный фильтр по навыкам и прочему, так что пользоваться ресурсом комфортно. Отдельно хочу отметить, что няня работает в моей семье уже три недели и за этот период никаких нареканий нет. ',
    href: 'https://vk.com/anya_levitskaya',
  },
  {
    image: toAsset(ImgUser4),
    name: 'Янис Аликин',
    date: '03 декабря 2021 г.',
    text: 'Когда для бабушки потребовалось нанять профессиональную сиделку, я решил подыскать подходящего специалиста на YouHelp. Достаточно быстро удалось найти несколько кандидатур, но в конечном итоге, после ряда собеседований, остановил свой выбор на сиделке по имени Надежда, которая обладала опытом и необходимыми навыками для ухода за лежачей больной. Порадовало, что на YouHelp есть отзывы о сиделках и возможность связываться напрямую через мессенджеры, это тоже помогло сделать правильный выбор. В общем, сервисом я вполне доволен, собственно, как и найденным здесь специалистом. При необходимости буду вновь обращаться.',
    href: 'https://vk.com/a_ya_tvoy_drug',
  },
  {
    image: toAsset(ImgUser3),
    name: 'Иван Старцев',
    date: '23 марта 2021 г.',
    text: 'Воспользовался возможностями сайта YouHelp первый раз, когда потребовалось найти профессионального репетитора по английскому языку, чтобы улучшить произношение и разговорную речь. Очень удобно, что на сайте в разделе "Репетитор" есть возможность применить фильтр, чтобы сразу увидеть только преподавателей, которые занимаются именно английским. Вариантов тут множество было и в конечном итоге мне удалось найти опытного репетитора по подходящей стоимости. Отдельно отмечу, что коммуникация с преподавателем через YouHelp организована классно, поэтому проблем в процессе не возникло. ',
    href: 'https://vk.com/starzev',
  },
  {
    image: toAsset(ImgUser2),
    name: 'Ксения Петухова',
    date: '20 декабря 2020 г.',
    text: 'Отличная задумка и качественное ее воплощение это редкость. Здесь же результат говорит сам за себя. Тысячи людей имеют возможность заработать, а по другую сторону нуждающиеся в помощи избавлены от вечной проблемы долгих поисков надёжных людей. Здесь все кандидаты проверены на благонадёжность. Заказываю услуги клининга помещений, от кабинета до актового зала. И после профсоюзных мероприятий всегда спокойна за сохранность материальных ценностей. Нравится наблюдать за развитием вашего портала. С 2020-го года много чего интересного внедрили и не останавливаетесь. Это радует! ',
    href: 'https://vk.com/ksu_8888',
  },
  {
    image: toAsset(ImgUser1),
    name: 'Наталья Зонова',
    date: '15 июля 2020 г.',
    text: 'Потребовалось провести генеральную уборку квартиры после косметического ремонта, поэтому решили с мужем обратиться на YouHelp, чтобы найти проверенного клинера. Выбор специалистов здесь действительно очень большой. Удобная фильтрация по ценам и прочим параметрам, что очень помогло быстро найти подходящего специалиста. Отдельно хочу отметить, что на YouHelp есть все необходимые данные о специалистах, поэтому без проблем удалось связаться с выбранным клинером и обсудить детали заказа. YouHelp выручает, так что определенно рекомендуем данный сервис и продолжим им пользоваться! ',
    href: 'https://vk.com/id4812765',
  },
];

export const FeedbacksList = () => {
  const breadcrumbs = [
    {
      path: '/',
      label: 'Главная',
    },
    {
      path: '',
      label: 'Отзывы о компании',
    },
  ];
  return (
    <Container>
      <Breadcrumbs LinkComponent={RoutedLink} items={breadcrumbs} sx={{ my: 2 }} />
      <Typography component="h1" sx={{ typography: { xs: 'h4', md: 'h1' }, m: 0, mb: { xs: 3, md: 5 } }}>
        Отзывы о компании
      </Typography>
      <Box sx={{ my: 5 }}>
        <div className="getreview-widget" data-widget-id="OUI8W4qGW5qxzWn2"></div>
      </Box>
      {reviews.map((review, i) => (
        <FeedbackItem key={`${i}-${review.name}`} {...review} />
      ))}
    </Container>
  );
};
